import { Component } from "react";
import { connect, ConnectedComponent } from "react-redux";
import { IStepsInfo, IStore, Step, BookingType } from "../../../DataTypes/storeTypes";
import { EnumValues } from "../../../../Common/enumHelper";
import { Image } from "../../../../Common/Image";
import { AppointmentNotesConnected } from "./AppointmentNotes";
import { AppointmentClientConnected } from "./AppointmentClient";
import { setStep } from "../../../Actions/actions";

interface IProps {
    stepsInfo: IStepsInfo;
    showNotes: boolean;
    showClientsSelect: boolean;
    bookingType: BookingType;
    setStep(step: Step);
}

class Summary extends Component<IProps> {
    render() {
        const keys = EnumValues.getNamesAndValues(Step);

        const steps = keys.map((k) => {
            const summary = this.props.stepsInfo[k.value];
            const sumKey = k.name.toLowerCase();

            if (!summary?.summary || (k.value === Step.Service && this.props.bookingType === BookingType.Class)) {
                return null;
            }

            return (
                <div key={k.value} className="summary-item">
                    <div className={`summary-icon ${sumKey}`}>
                        <Image src={`/images/confirmation/${sumKey}.svg`} width="24" height="24" alt={k.name} />
                    </div>
                    <div className="summary-text">
                        <label className="text-uppercase">{k.name}:</label>
                        <div>
                            <a href="#" onClick={() => this.props.setStep(k.value as any)}>
                                {summary.summary}
                            </a>
                        </div>
                    </div>
                </div>
            );
        });

        return (
            <div className="confirmation-details">
                <div className="row mt-2 mb-2">
                    <div className="col-12">
                        {steps}

                        {this.props.showNotes && <AppointmentNotesConnected />}

                        {this.props.showClientsSelect && <AppointmentClientConnected />}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        stepsInfo: state.stepsInfo,
        showNotes: !state.common.bookedAppointment,
        showClientsSelect:
            state.common.clients &&
            (state.common.clients.length > 1 ||
                !state.common.clients.some((x) => x.id == state.common.loggedInClientId)),
        bookingType: state.initialSettings.type,
    };
};

const mapDispatchToProps = (dispatch, ownProps: IProps): IProps => {
    return {
        ...ownProps,
        setStep: (step: Step) => dispatch(setStep(step)),
    };
};

export const SummaryConnected: ConnectedComponent<typeof Summary, any> = connect(
    mapStateToProps,
    mapDispatchToProps
)(Summary);
